// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".agency-page-header-separator[data-v-088b3fe2]{box-shadow:inset 0 -1px 0 0 #d4d4d4;height:2.5rem}[data-v-088b3fe2] .s2-page-header-classic__last-update{position:relative;z-index:24}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
